exports.install = function (Vue, options) {
	//添加子设备摄像头
	Vue.prototype.addvideo = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		return this.axiospost("/api/video/add",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
	//修改摄像头
	Vue.prototype.editvideo = function(value)
	{
		return this.axiospost("/api/video/update",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
	//删除摄像头
	Vue.prototype.delvideo = function(value)
	{
		this.axiospost("/api/video/delete",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
	//启动暂停摄像头
	Vue.prototype.startpause = function(value)
	{
		this.axiospost("/api/video/startPause",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
}